import { AxiosInstance } from 'axios';
import { insertId } from '../../insertId';
import { toResponse } from '../../genericToResponse';
import { IGroup } from 'src/views/Admin/ItemGroups/types';

export default (api: AxiosInstance, url: string) => async (group: IGroup) => {
  const urlWithId = insertId(url, group.parameter.id);
  const response = await api.post(urlWithId, group);
  return toResponse(response.data) as IGroup;
};



// WEBPACK FOOTER //
// ./src/services/api/admin/itemGroups/update.ts